import React from 'react';
import SectionCard from './SectionCard';
import { educationData, certificationsData } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const EducationSection = ({ isDoorOpen }) => {
  const { t, language } = useLanguage();
  
  // Get data for current language
  const education = educationData[language] || educationData.fr;
  const certifications = certificationsData[language] || certificationsData.fr;
  const mainCertifications = certifications.slice(0, 8);

  return (
    <SectionCard
      id="formations"
      icon="🎓"
      title={t.education.title}
      subtitle={t.education.subtitle}
      isDoorOpen={isDoorOpen}
    >
      <div className="grid-2">
        <div>
          <h3>{t.education.degrees}</h3>
          <ul>
            {education.map((edu) => (
              <li key={edu.id}>
                <strong>{edu.degree}</strong> – {edu.institution}
                {edu.specialization && <span> ({edu.specialization})</span>}
                <span className="edu-status"> [{edu.status}]</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3>{t.education.certifications}</h3>
          <ul>
            {mainCertifications.map((cert) => (
              <li key={cert.id}>
                <strong>{cert.title}</strong> – {cert.issuer} ({cert.year})
                {cert.credentialId && (
                  <span className="credential-id"> ID: {cert.credentialId}</span>
                )}
              </li>
            ))}
          </ul>
          <div className="chips">
            <div className="chip">Psychological First Aid</div>
            <div className="chip">Safeguarding</div>
            <div className="chip">{language === 'fr' ? 'Gestion de projet' : 'Project Management'}</div>
            <div className="chip">{language === 'fr' ? 'Genre & inclusion' : 'Gender & Inclusion'}</div>
            <div className="chip">{language === 'fr' ? 'VBG & Protection' : 'GBV & Protection'}</div>
            <div className="chip">Leadership</div>
          </div>
        </div>
      </div>
    </SectionCard>
  );
};

export default EducationSection;
